export default "__VITE_ASSET__Bs03ycSW__"